import { useDealershipPhones } from '~/context/dealership/StaticContext';

export default function useServicePhone() {
  const phones = useDealershipPhones();

  return (
    phones.find(phone => phone.label.toLowerCase().includes('service')) ??
    phones[0]
  );
}
